import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useDispatch, useSelector } from 'react-redux'
import * as yup from 'yup'
import { IRootReducerState } from 'state/reducers'
import { getFeatureFlags } from './actions'

const useSupportFeatures = () => {
  const selectedRegion = useSelector((state: IRootReducerState) => state.region.selectedRegion)
  const dispatch = useDispatch()
  const enabledFeaturesQuery = useQuery(['enabled-features', selectedRegion], async () => {
    if (!selectedRegion) {
      return []
    }
    const result = await dispatch(getFeatureFlags())
    const schema = yup.object({
      Data: yup.array(yup.string().defined())
    })
    return (await schema.validate(result)).Data
  })

  return React.useMemo(() => enabledFeaturesQuery.data ?? [], [enabledFeaturesQuery.data])
}

export default useSupportFeatures
